module.exports = __webpack_public_path__ + "img/tag-close.42da5452.svg";